import { mensaje, type CodigoMensaje, type ErrorRespuesta } from '@reembolsables/shared';

/** Thin fetch wrapper: JSON in/out, cookies included, errors carry the catalogue message. */
export class ErrorApi extends Error {
  constructor(
    public readonly estado: number,
    public readonly codigo: string,
    mensajeTexto: string,
    public readonly cuerpo: unknown,
  ) {
    super(mensajeTexto);
  }
}

export async function api<T>(ruta: string, init: RequestInit = {}): Promise<T> {
  // only declare JSON when there is a JSON body: Fastify rejects an empty body with that content type
  const headers: Record<string, string> =
    typeof init.body === 'string' ? { 'Content-Type': 'application/json' } : {};
  const res = await fetch(ruta, { credentials: 'same-origin', headers, ...init });
  if (res.status === 204) return undefined as T;
  const cuerpo: unknown = await res.json().catch(() => null);
  if (!res.ok) {
    const e = (cuerpo ?? {}) as Partial<ErrorRespuesta>;
    throw new ErrorApi(
      res.status,
      e.codigo ?? 'ERROR_INESPERADO',
      e.mensaje ?? mensaje('ERROR_INESPERADO'),
      cuerpo,
    );
  }
  return cuerpo as T;
}

export const textoDeError = (e: unknown): string =>
  e instanceof ErrorApi ? e.message : mensaje('ERROR_INESPERADO' satisfies CodigoMensaje);
